export default "/images/vendor/flag-icon-css/flags/4x3/de.svg?6435bf24d148ca7248e78a89c1d026ca";